import { useState, useEffect } from 'react';
import { fetchKoriData } from '@/services/koriService';

export function useKoriData(id) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!id) return;

    let cancelled = false;
    (async () => {
      setLoading(true);
      setError(null);

      try {
        const res = await fetchKoriData({ id });
        if (!cancelled) setData(res);
      }
      catch (e) {
        if (!cancelled) setError(e);
      }
      finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [id]);

  return { data, loading, error, setData };
};
